import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import 'probonio-shared-ui/module/error/sentry';
import { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import 'simplebar-react/dist/simplebar.min.css';
import { SnackbarProvider } from './component/snackbar';
import './lang';

import { MATERIAL_THEME } from './theme';

function checkLocalStorageSupport() {
  try {
    if (!window.localStorage) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
}

const root = createRoot(document.getElementById('root')!);

if (!checkLocalStorageSupport()) {
  root.render(<div>Bitte erteilen Sie unserer App Zugriff auf Ihren LocalStorage, um die korrekte Funktionalität zu gewährleisten.</div>);
} else {
  const App = lazy(() => import('./App'));

  root.render(
    <ThemeProvider theme={MATERIAL_THEME}>
      <CssBaseline />
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </ThemeProvider>,
  );
}
